import { useSelector } from 'react-redux';
import Constants from '../../constants';
import {
  getContestLeaderboard as getContestLeaderboardCricket,
  getContestUserLeaderboard as getContestUserLeaderboardCricket,
  getMyMatchTeamList as getMyMatchTeamListCricket,
  joinContest as joinContestCricket,
  getMyUpcomingMatches as getMyUpcomingMatchesCricket,
  getMyLiveMatches as getMyLiveMatchesCricket,
  getMyCompletedMatches as getMyCompletedMatchesCricket,
  getMyRecentMatches as getMyRecentMatchesCricket,
  getMyFixtureJoinedContest as getMyFixtureJoinedContestCricket,
  getMyLiveJoinedContest as getMyLiveJoinedContestCricket,
  getMyResultJoinedContest as getMyResultJoinedContestCricket,
  fantasyMatchClick as fantasyMatchClickCricket,
  matchItem as matchItemCricket,
  getUpcomingMatchList as getUpcomingMatchListCricket,
  getAllContestList as getAllContestListCricket,
  getPlayerList as getPlayerListCricket,
  getContestDetailsById as getContestDetailsByIdCricket,
  getMatchDetailsById as getMatchDetailsByIdCricket,
  getContestListByContestTypeId as getContestListByContestTypeIdCricket,
  updateContestFilter as updateContestFilterCricket,
  getMyTeamDetailsByTeamId as getMyTeamDetailsByTeamIdCricket,
  switchContestTeam as switchContestTeamCricket,
  setMyTeamList as setMyTeamListCricket,
  createTeam as createTeamCricket,
  editTeam as editTeamCricket,
  getContestTypes as getContestTypesCricket,
  setContestTypes as setContestTypesCricket,
  getContestListByContestType as getContestListByContestTypeCricket,
  getContestListByCategory as getContestListByCategoryCricket,
  getContestListByCategoryId as getContestListByCategoryIdCricket,
  joinWithMultipleTeam as joinWithMultipleTeamCricket,
  getContestCategories as getContestCategoriesCricket,
  setContestCategories as setContestCategoriesCricket,
  setMyContestList as setMyContestListCricket,
  setAllContestList
} from '../../actions/fantasy-cricket-action-types';
import {
  getContestLeaderboard as getContestLeaderboardYesNo,
  getContestUserLeaderboard as getContestUserLeaderboardYesNo,
  joinContest as joinContestYesNo,
  getMyUpcomingMatches as getMyUpcomingMatchesYesNo,
  getMyLiveMatches as getMyLiveMatchesYesNo,
  getMyCompletedMatches as getMyCompletedMatchesYesNo,
  getMyFixtureJoinedContest as getMyFixtureJoinedContestYesNo,
  getMyLiveJoinedContest as getMyLiveJoinedContestYesNo,
  getMyResultJoinedContest as getMyResultJoinedContestYesNo,
  fantasyMatchClick as fantasyMatchClickYesNo,
  matchItem as matchItemYesNo,
  getUpcomingMatchList as getUpcomingMatchListYesNo,
  getAllContestList as getAllContestListYesNo,
  getPlayerList as getPlayerListYesNo,
  getContestDetailsById as getContestDetailsByIdYesNo,
  getMatchDetailsById as getMatchDetailsByIdYesNo,
  getContestListByContestTypeId as getContestListByContestTypeIdYesNo,
  updateContestFilter as updateContestFilterYesNo,
  getMyTeamDetailsByTeamId as getMyTeamDetailsByTeamIdYesNo,
  getContestTypes as getContestTypesYesNo,
  setContestTypes as setContestTypesYesNo,
  getContestListByContestType as getContestListByContestTypeYesNo,
  getContestListByCategory as getContestListByCategoryYesNo,
  getContestListByCategoryId as getContestListByCategoryIdYesNo,
  setMyContestList as setMyContestListYesNo,
  checkedMyAnswer,
  getQuestionList,
  setAllContestList as yesOrNoSetAllContestList
} from '../../actions/fantasy-yes-no-action-types';

import {
  getContestLeaderboard as getContestLeaderboardSubstitute,
  getContestUserLeaderboard as getContestUserLeaderboardSubstitute,
  getMyMatchTeamList as getMyMatchTeamListSubstitute,
  joinContest as joinContestSubstitute,
  getMyUpcomingMatches as getMyUpcomingMatchesSubstitute,
  getMyLiveMatches as getMyLiveMatchesSubstitute,
  getMyCompletedMatches as getMyCompletedMatchesSubstitute,
  getMyRecentMatches as getMyRecentMatchesSubstitute,
  getMyFixtureJoinedContest as getMyFixtureJoinedContestSubstitute,
  getMyLiveJoinedContest as getMyLiveJoinedContestSubstitute,
  getMyResultJoinedContest as getMyResultJoinedContestSubstitute,
  fantasyMatchClick as fantasyMatchClickSubstitute,
  matchItem as matchItemSubstitute,
  getUpcomingMatchList as getUpcomingMatchListSubstitute,
  getAllContestList as getAllContestListSubstitute,
  getPlayerList as getPlayerListSubstitute,
  getContestDetailsById as getContestDetailsByIdSubstitute,
  getMatchDetailsById as getMatchDetailsByIdSubstitute,
  getContestListByContestTypeId as getContestListByContestTypeIdSubstitute,
  updateContestFilter as updateContestFilterSubstitute,
  getMyTeamDetailsByTeamId as getMyTeamDetailsByTeamIdSubstitute,
  switchContestTeam as switchContestTeamSubstitute,
  setMyTeamList as setMyTeamListSubstitute,
  createTeam as createTeamSubstitute,
  editTeam as editTeamSubstitute,
  getContestTypes as getContestTypesSubstitute,
  setContestTypes as setContestTypesSubstitute,
  getContestListByContestType as getContestListByContestTypeSubstitute,
  getContestListByCategory as getContestListByCategorySubstitute,
  getContestListByCategoryId as getContestListByCategoryIdSubstitute,
  joinWithMultipleTeam as joinWithMultipleTeamSubstitute,
  setMyContestList as setMyContestListSubstitute,
  addSubstitutePlayer as addSubstitutePlayerSubstitute,
  getSubstituteTeamById as getSubstituteTeamByIdSubstitute
} from '../../actions/fantasy-substitute-action-types';

import {
  getContestLeaderboard as getContestLeaderboardKabaddi,
  getContestUserLeaderboard as getContestUserLeaderboardKabaddi,
  getMyMatchTeamList as getMyMatchTeamListKabaddi,
  joinContest as joinContestKabaddi,
  getMyUpcomingMatches as getMyUpcomingMatchesKabaddi,
  getMyLiveMatches as getMyLiveMatchesKabaddi,
  getMyCompletedMatches as getMyCompletedMatchesKabaddi,
  getMyRecentMatches as getMyRecentMatchesKabaddi,
  getMyFixtureJoinedContest as getMyFixtureJoinedContestKabaddi,
  getMyLiveJoinedContest as getMyLiveJoinedContestKabaddi,
  getMyResultJoinedContest as getMyResultJoinedContestKabaddi,
  fantasyMatchClick as fantasyMatchClickKabaddi,
  matchItem as matchItemKabaddi,
  getUpcomingMatchList as getUpcomingMatchListKabaddi,
  getAllContestList as getAllContestListKabaddi,
  getPlayerList as getPlayerListKabaddi,
  getContestDetailsById as getContestDetailsByIdKabaddi,
  getMatchDetailsById as getMatchDetailsByIdKabaddi,
  getContestListByContestTypeId as getContestListByContestTypeIdKabaddi,
  updateContestFilter as updateContestFilterKabaddi,
  getMyTeamDetailsByTeamId as getMyTeamDetailsByTeamIdKabaddi,
  switchContestTeam as switchContestTeamKabaddi,
  setMyTeamList as setMyTeamListKabaddi,
  createTeam as createTeamKabaddi,
  editTeam as editTeamKabaddi,
  getContestTypes as getContestTypesKabaddi,
  setContestTypes as setContestTypesKabaddi,
  getContestListByContestType as getContestListByContestTypeKabaddi,
  getContestListByCategory as getContestListByCategoryKabaddi,
  getContestListByCategoryId as getContestListByCategoryIdKabaddi,
  joinWithMultipleTeam as joinWithMultipleTeamKabaddi,
  setMyContestList as setMyContestListKabaddi
} from '../../actions/fantasy-kabaddi-action-types';

import {
  getContestLeaderboard as getContestLeaderboardFootball,
  getContestUserLeaderboard as getContestUserLeaderboardFootball,
  getMyMatchTeamList as getMyMatchTeamListFootball,
  joinContest as joinContestFootball,
  getMyUpcomingMatches as getMyUpcomingMatchesFootball,
  getMyLiveMatches as getMyLiveMatchesFootball,
  getMyCompletedMatches as getMyCompletedMatchesFootball,
  getMyRecentMatches as getMyRecentMatchesFootball,
  getMyFixtureJoinedContest as getMyFixtureJoinedContestFootball,
  getMyLiveJoinedContest as getMyLiveJoinedContestFootball,
  getMyResultJoinedContest as getMyResultJoinedContestFootball,
  fantasyMatchClick as fantasyMatchClickFootball,
  matchItem as matchItemFootball,
  getUpcomingMatchList as getUpcomingMatchListFootball,
  getAllContestList as getAllContestListFootball,
  getPlayerList as getPlayerListFootball,
  getContestDetailsById as getContestDetailsByIdFootball,
  getMatchDetailsById as getMatchDetailsByIdFootball,
  getContestListByContestTypeId as getContestListByContestTypeIdFootball,
  updateContestFilter as updateContestFilterFootball,
  getMyTeamDetailsByTeamId as getMyTeamDetailsByTeamIdFootball,
  switchContestTeam as switchContestTeamFootball,
  setMyTeamList as setMyTeamListFootball,
  createTeam as createTeamFootball,
  editTeam as editTeamFootball,
  getContestTypes as getContestTypesFootball,
  setContestTypes as setContestTypesFootball,
  getContestListByContestType as getContestListByContestTypeFootball,
  getContestListByCategory as getContestListByCategoryFootball,
  getContestListByCategoryId as getContestListByCategoryIdFootball,
  joinWithMultipleTeam as joinWithMultipleTeamFootball,
  getContestCategories as getContestCategoriesFootball,
  setContestCategories as setContestCategoriesFootball,
  setMyContestList as setMyContestListFootball,
  setAllContestList as setAllContestListFootball
} from '../../actions/fantasy-football-action-types';

const useGame = (gameType = '') => {
  const {
    user: {
      gameType: _gameType = '',
      userId = '',
      affiliateId = '',
      affiliateLink = '',
      referralLink = '',
      referralId = '',
      balanceInfo = {},
      phones = [],
      emails = [],
      firstName = '',
      lastName = '',
      teamName = ''
    },
    fantasy_substitute,
    fantasy_kabaddi,
    fantasy_yes_no,
    fantasy_cricket,
    fantasy_football,
    app: { shareContestStatus = {}, language = 'en' }
  } = useSelector((state: any) => state);
  if (!gameType) {
    gameType = _gameType;
  }
  const { contestCategories = [] } = fantasy_cricket;

  if (gameType === Constants.GameType.FANTASY_SUBSTITUTION)
    return {
      ...fantasy_substitute,
      gameType,
      contestCategories,
      userId,
      affiliateId,
      affiliateLink,
      referralLink,
      referralId,
      balanceInfo,
      shareContestStatus,
      phones,
      emails,
      firstName,
      lastName,
      teamName,
      language,
      getContestLeaderboard: getContestLeaderboardSubstitute,
      getContestUserLeaderboard: getContestUserLeaderboardSubstitute,
      getMyMatchTeamList: getMyMatchTeamListSubstitute,
      joinContest: joinContestSubstitute,
      getMyUpcomingMatches: getMyUpcomingMatchesSubstitute,
      getMyLiveMatches: getMyLiveMatchesSubstitute,
      getMyCompletedMatches: getMyCompletedMatchesSubstitute,
      getMyRecentMatches: getMyRecentMatchesSubstitute,
      getMyFixtureJoinedContest: getMyFixtureJoinedContestSubstitute,
      getMyLiveJoinedContest: getMyLiveJoinedContestSubstitute,
      getMyResultJoinedContest: getMyResultJoinedContestSubstitute,
      fantasyMatchClick: fantasyMatchClickSubstitute,
      matchItem: matchItemSubstitute,
      getUpcomingMatchList: getUpcomingMatchListSubstitute,
      getAllContestList: getAllContestListSubstitute,
      getPlayerList: getPlayerListSubstitute,
      getContestDetailsById: getContestDetailsByIdSubstitute,
      getMatchDetailsById: getMatchDetailsByIdSubstitute,
      getContestListByContestTypeId: getContestListByContestTypeIdSubstitute,
      updateContestFilter: updateContestFilterSubstitute,
      getMyTeamDetailsByTeamId: getMyTeamDetailsByTeamIdSubstitute,
      switchContestTeam: switchContestTeamSubstitute,
      setMyTeamList: setMyTeamListSubstitute,
      createTeam: createTeamSubstitute,
      editTeam: editTeamSubstitute,
      getContestTypes: getContestTypesSubstitute,
      setContestTypes: setContestTypesSubstitute,
      getContestListByContestType: getContestListByContestTypeSubstitute,
      getContestListByCategory: getContestListByCategorySubstitute,
      getContestListByCategoryId: getContestListByCategoryIdSubstitute,
      joinWithMultipleTeam: joinWithMultipleTeamSubstitute,
      setMyContestList: setMyContestListSubstitute,
      addSubstitutePlayer: addSubstitutePlayerSubstitute,
      getSubstituteTeamById: getSubstituteTeamByIdSubstitute,
      getContestCategories: getContestCategoriesCricket
    };
  else if (gameType === Constants.GameType.FANTASY_KABADDI)
    return {
      ...fantasy_kabaddi,
      gameType,
      contestCategories,
      userId,
      affiliateId,
      affiliateLink,
      referralLink,
      referralId,
      balanceInfo,
      shareContestStatus,
      phones,
      emails,
      firstName,
      lastName,
      teamName,
      language,
      getContestLeaderboard: getContestLeaderboardKabaddi,
      getContestUserLeaderboard: getContestUserLeaderboardKabaddi,
      getMyMatchTeamList: getMyMatchTeamListKabaddi,
      joinContest: joinContestKabaddi,
      getMyUpcomingMatches: getMyUpcomingMatchesKabaddi,
      getMyLiveMatches: getMyLiveMatchesKabaddi,
      getMyCompletedMatches: getMyCompletedMatchesKabaddi,
      getMyRecentMatches: getMyRecentMatchesKabaddi,
      getMyFixtureJoinedContest: getMyFixtureJoinedContestKabaddi,
      getMyLiveJoinedContest: getMyLiveJoinedContestKabaddi,
      getMyResultJoinedContest: getMyResultJoinedContestKabaddi,
      fantasyMatchClick: fantasyMatchClickKabaddi,
      matchItem: matchItemKabaddi,
      getUpcomingMatchList: getUpcomingMatchListKabaddi,
      getAllContestList: getAllContestListKabaddi,
      getPlayerList: getPlayerListKabaddi,
      getContestDetailsById: getContestDetailsByIdKabaddi,
      getMatchDetailsById: getMatchDetailsByIdKabaddi,
      getContestListByContestTypeId: getContestListByContestTypeIdKabaddi,
      updateContestFilter: updateContestFilterKabaddi,
      getMyTeamDetailsByTeamId: getMyTeamDetailsByTeamIdKabaddi,
      switchContestTeam: switchContestTeamKabaddi,
      setMyTeamList: setMyTeamListKabaddi,
      createTeam: createTeamKabaddi,
      editTeam: editTeamKabaddi,
      getContestTypes: getContestTypesKabaddi,
      setContestTypes: setContestTypesKabaddi,
      getContestListByContestType: getContestListByContestTypeKabaddi,
      getContestListByCategory: getContestListByCategoryKabaddi,
      getContestListByCategoryId: getContestListByCategoryIdKabaddi,
      joinWithMultipleTeam: joinWithMultipleTeamKabaddi,
      setMyContestList: setMyContestListKabaddi,
      getContestCategories: getContestCategoriesCricket
    };
  else if (gameType === Constants.GameType.FANTASY_YES_NO)
    return {
      ...fantasy_yes_no,
      gameType,
      contestCategories,
      userId,
      affiliateId,
      affiliateLink,
      referralLink,
      referralId,
      balanceInfo,
      shareContestStatus,
      phones,
      emails,
      firstName,
      lastName,
      teamName,
      language,
      getContestLeaderboard: getContestLeaderboardYesNo,
      getContestUserLeaderboard: getContestUserLeaderboardYesNo,
      joinContest: joinContestYesNo,
      getMyUpcomingMatches: getMyUpcomingMatchesYesNo,
      getMyLiveMatches: getMyLiveMatchesYesNo,
      getMyCompletedMatches: getMyCompletedMatchesYesNo,
      getMyFixtureJoinedContest: getMyFixtureJoinedContestYesNo,
      getMyLiveJoinedContest: getMyLiveJoinedContestYesNo,
      getMyResultJoinedContest: getMyResultJoinedContestYesNo,
      fantasyMatchClick: fantasyMatchClickYesNo,
      matchItem: matchItemYesNo,
      getUpcomingMatchList: getUpcomingMatchListYesNo,
      getAllContestList: getAllContestListYesNo,
      getPlayerList: getPlayerListYesNo,
      getContestDetailsById: getContestDetailsByIdYesNo,
      getMatchDetailsById: getMatchDetailsByIdYesNo,
      getContestListByContestTypeId: getContestListByContestTypeIdYesNo,
      updateContestFilter: updateContestFilterYesNo,
      getMyTeamDetailsByTeamId: getMyTeamDetailsByTeamIdYesNo,
      getContestTypes: getContestTypesYesNo,
      setContestTypes: setContestTypesYesNo,
      getContestListByContestType: getContestListByContestTypeYesNo,
      getContestListByCategory: getContestListByCategoryYesNo,
      getContestListByCategoryId: getContestListByCategoryIdYesNo,
      setMyContestList: setMyContestListYesNo,
      getContestCategories: getContestCategoriesCricket,
      checkedMyAnswer,
      getQuestionList,
      setAllContestList: yesOrNoSetAllContestList
    };
  else if (gameType === Constants.GameType.FANTASY_FOOTBALL) {
    return {
      ...fantasy_football,
      contestCategories,
      gameType,
      userId,
      affiliateId,
      affiliateLink,
      referralLink,
      referralId,
      balanceInfo,
      shareContestStatus,
      phones,
      emails,
      firstName,
      lastName,
      teamName,
      language,
      getContestLeaderboard: getContestLeaderboardFootball,
      getContestUserLeaderboard: getContestUserLeaderboardFootball,
      getMyMatchTeamList: getMyMatchTeamListFootball,
      joinContest: joinContestFootball,
      getMyUpcomingMatches: getMyUpcomingMatchesFootball,
      getMyLiveMatches: getMyLiveMatchesFootball,
      getMyCompletedMatches: getMyCompletedMatchesFootball,
      getMyRecentMatches: getMyRecentMatchesFootball,
      getMyFixtureJoinedContest: getMyFixtureJoinedContestFootball,
      getMyLiveJoinedContest: getMyLiveJoinedContestFootball,
      getMyResultJoinedContest: getMyResultJoinedContestFootball,
      fantasyMatchClick: fantasyMatchClickFootball,
      matchItem: matchItemFootball,
      getUpcomingMatchList: getUpcomingMatchListFootball,
      getAllContestList: getAllContestListFootball,
      getPlayerList: getPlayerListFootball,
      getContestDetailsById: getContestDetailsByIdFootball,
      getMatchDetailsById: getMatchDetailsByIdFootball,
      getContestListByContestTypeId: getContestListByContestTypeIdFootball,
      updateContestFilter: updateContestFilterFootball,
      getMyTeamDetailsByTeamId: getMyTeamDetailsByTeamIdFootball,
      switchContestTeam: switchContestTeamFootball,
      setMyTeamList: setMyTeamListFootball,
      createTeam: createTeamFootball,
      editTeam: editTeamFootball,
      getContestTypes: getContestTypesFootball,
      setContestTypes: setContestTypesFootball,
      getContestListByContestType: getContestListByContestTypeFootball,
      getContestListByCategory: getContestListByCategoryFootball,
      getContestListByCategoryId: getContestListByCategoryIdFootball,
      joinWithMultipleTeam: joinWithMultipleTeamFootball,
      getContestCategories: getContestCategoriesFootball,
      setContestCategories: setContestCategoriesFootball,
      setMyContestList: setMyContestListFootball,
      setAllContestList: setAllContestListFootball
    };
  } else
    return {
      ...fantasy_cricket,
      gameType,
      userId,
      affiliateId,
      affiliateLink,
      referralLink,
      referralId,
      balanceInfo,
      shareContestStatus,
      phones,
      emails,
      firstName,
      lastName,
      teamName,
      language,
      getContestLeaderboard: getContestLeaderboardCricket,
      getContestUserLeaderboard: getContestUserLeaderboardCricket,
      getMyMatchTeamList: getMyMatchTeamListCricket,
      joinContest: joinContestCricket,
      getMyUpcomingMatches: getMyUpcomingMatchesCricket,
      getMyLiveMatches: getMyLiveMatchesCricket,
      getMyCompletedMatches: getMyCompletedMatchesCricket,
      getMyRecentMatches: getMyRecentMatchesCricket,
      getMyFixtureJoinedContest: getMyFixtureJoinedContestCricket,
      getMyLiveJoinedContest: getMyLiveJoinedContestCricket,
      getMyResultJoinedContest: getMyResultJoinedContestCricket,
      fantasyMatchClick: fantasyMatchClickCricket,
      matchItem: matchItemCricket,
      getUpcomingMatchList: getUpcomingMatchListCricket,
      getAllContestList: getAllContestListCricket,
      getPlayerList: getPlayerListCricket,
      getContestDetailsById: getContestDetailsByIdCricket,
      getMatchDetailsById: getMatchDetailsByIdCricket,
      getContestListByContestTypeId: getContestListByContestTypeIdCricket,
      updateContestFilter: updateContestFilterCricket,
      getMyTeamDetailsByTeamId: getMyTeamDetailsByTeamIdCricket,
      switchContestTeam: switchContestTeamCricket,
      setMyTeamList: setMyTeamListCricket,
      createTeam: createTeamCricket,
      editTeam: editTeamCricket,
      getContestTypes: getContestTypesCricket,
      setContestTypes: setContestTypesCricket,
      getContestListByContestType: getContestListByContestTypeCricket,
      getContestListByCategory: getContestListByCategoryCricket,
      getContestListByCategoryId: getContestListByCategoryIdCricket,
      joinWithMultipleTeam: joinWithMultipleTeamCricket,
      getContestCategories: getContestCategoriesCricket,
      setContestCategories: setContestCategoriesCricket,
      setMyContestList: setMyContestListCricket,
      setAllContestList: setAllContestList
    };
};
export default useGame;
